import { CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostEntity } from '@festina/life-general-types/life/hooks/CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostEntity'

export const useFetchCommitmentVersionSimulation =
  CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostEntity.useSuspenseQuery
